import React, { FC } from 'react';
import styles from './meta-box.module.sass';

interface Props {
  customClassName?: string[],
  content: any
}

export const MetaBox: FC<Props> = (props) => {
  return <div className={`${styles.metaBox} ${props.customClassName ?? ''}`}>
    <div className={styles.title}><i className="fas fa-info-circle" /></div>
    {props.content}
  </div>;
};

export default MetaBox;
